import { useEffect } from "react";

export const VOLCAN_SIDEBAR_WIDTH_OPEN = "230px";
export const VOLCAN_SIDEBAR_WIDTH_CLOSED = "80px";
export const VOLCAN_SIDEBAR_WIDTH_OPEN_MOBILE = "210px";
export const VOLCAN_SIDEBAR_WIDTH_CLOSED_MOBILE = "72px";

function resolveSidebarWidth(sidebarOpen) {
  if (
    typeof window !== "undefined" &&
    window.matchMedia("(max-width: 768px)").matches
  ) {
    // En móvil el menú abierto va encima del contenido (overlay);
    // el área útil solo reserva el rail cerrado.
    return VOLCAN_SIDEBAR_WIDTH_CLOSED_MOBILE;
  }
  return sidebarOpen ? VOLCAN_SIDEBAR_WIDTH_OPEN : VOLCAN_SIDEBAR_WIDTH_CLOSED;
}

export function useVolcanSidebarLayout(sidebarOpen) {
  useEffect(() => {
    const root = document.documentElement;

    const apply = () => {
      root.classList.add("has-volcan-sidebar");
      root.style.setProperty(
        "--volcan-sidebar-width",
        resolveSidebarWidth(sidebarOpen),
      );
    };

    apply();

    const mq = window.matchMedia("(max-width: 768px)");
    const onChange = () => apply();
    mq.addEventListener("change", onChange);

    return () => {
      mq.removeEventListener("change", onChange);
      root.classList.remove("has-volcan-sidebar");
      root.style.removeProperty("--volcan-sidebar-width");
    };
  }, [sidebarOpen]);
}
